import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContentTitleModule } from '@app/modules/content-title/content-title.module';
import { DirectivesModule } from '@app/modules/directives.module';
import { EmojiButtonComponent } from '@app/modules/emoji-button/emoji-button.component';
import { FullHeightContainerModule } from '@app/modules/full-height-container/full-height-container.module';
import { ListPostLineModule } from '@app/modules/list-post-line/list-post-line.module';
import { IonicModule } from '@ionic/angular';
import { PositiveFeedbackQuestionComponent } from './positive-feedback-question.component';

@NgModule({
  declarations: [PositiveFeedbackQuestionComponent],
  imports: [
    CommonModule,
    IonicModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    EmojiButtonComponent,
    ListPostLineModule,
    FullHeightContainerModule,
    ContentTitleModule
  ],
  exports: [PositiveFeedbackQuestionComponent]
})
export class PositiveFeedbackQuestionModule {}
